export const EMPTY_TEXT = '--';

export const REPORT_BRAND_NAME = '';

export function isValidValue(value) {
  return value !== undefined && value !== null && value !== '';
}

export function hasValueDeep(value) {
  if (!isValidValue(value)) return false;
  if (Array.isArray(value)) return value.some((item) => hasValueDeep(item));
  if (typeof value === 'object') {
    return Object.keys(value).some((key) => hasValueDeep(value[key]));
  }
  return true;
}

export function pickText(...values) {
  const matched = values.find((value) => isValidValue(value));
  return isValidValue(matched) ? String(matched) : EMPTY_TEXT;
}

export function getReportBrandName(report = {}) {
  const inputParams = report.inputParams || {};
  const brandName = [
    report.orgName,
    report.mchName,
    report.merchantName,
    report.storeName,
    report.clinicName,
    report.hospitalName,
    report.organizationName,
    report.organName,
    inputParams.mchName,
    inputParams.merchantName,
    inputParams.storeName,
  ].find((value) => isValidValue(value) && String(value).trim());

  return isValidValue(brandName) ? String(brandName).trim() : REPORT_BRAND_NAME;
}

export function toArray(value) {
  if (Array.isArray(value)) return value.filter((item) => isValidValue(item));
  if (!isValidValue(value)) return [];
  return [value];
}

export function formatReportDate(value) {
  if (!isValidValue(value)) return '';
  return String(value).replace(/\//g, '-').split(/[ T]/)[0];
}

export function stripFieldLabel(value, label) {
  if (!isValidValue(value)) return '';
  const text = String(value).trim();
  const prefix = ['【', label, '】'].join('');
  return text.startsWith(prefix) ? text.slice(prefix.length).trim() : text;
}

export function maskMobile(value) {
  if (!isValidValue(value)) return EMPTY_TEXT;
  const text = String(value);
  if (text.length < 8) return text;
  return text.replace(/^(\d{3})\d+(\d{4})$/, '$1****$2');
}

export function clampScore(value) {
  const score = Number(value);
  if (Number.isNaN(score)) return 0;
  return Math.max(0, Math.min(100, score));
}

export function splitParagraphs(value) {
  if (!isValidValue(value)) return [];
  return String(value)
    .split(/\n|；|;/)
    .map((item) => item.trim())
    .filter(Boolean);
}
